import React from "react";
import { useCombinedContext } from "../../context/CombinedContext";
import "./Loader.css";

const Loader = () => {
  const { loading } = useCombinedContext();

  if (!loading) return null; // Ensure no unnecessary rendering when not loading

  return (
    <div className="loader-container">
      <div className="rotating-circle"></div>
    </div>
  );
};

export default Loader;
